import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-100">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <p className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
          <i className="ri-file-search-line" /> 页面不存在
        </p>
        <h2 className="font-heading text-xl md:text-2xl font-bold mt-4">这一页没能收录进档案</h2>
        <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-2 text-sm text-foreground-500">你访问的页面可能已被整理或不存在。</p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="rounded-full bg-primary-600 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap">
            返回首页
          </Link>
          <Link to="/archive" className="rounded-full border border-foreground-300 px-5 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap">
            进入分类档案库
          </Link>
        </div>
      </div>
    </div>
  );
}